import { render, staticRenderFns } from "./DatatableListAdmEdit.vue?vue&type=template&id=3dc37104&"
import script from "./DatatableListAdmEdit.vue?vue&type=script&lang=js&"
export * from "./DatatableListAdmEdit.vue?vue&type=script&lang=js&"
import style0 from "./DatatableListAdmEdit.vue?vue&type=style&index=0&id=3dc37104&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports